import '.e1{font-size:1.125rem;}.ssr-plugin'
import '.e9{line-height:1.75rem;}.ssr-plugin'
import '.ij{text-decoration:none;}.ssr-plugin'
import '.f9{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="e1 e9"
    >
      {translations.privacySubtitle}{' '}
      <a className="ij f9"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="ij f9"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
